<template>
  <div class="bg-white p-12">
    <div class="flex flex-nowrap space-x-20">
      <div class="w-11.5rem h-2.5rem mb-7">
        <img src="@/assets/image/logo.png" class="w-full h-full" />
      </div>
      <el-steps :active="1" align-center class="w-36.5rem step">
        <el-step :title="$t('提交订单')"></el-step>
        <el-step :title="$t('付款')"></el-step>
        <el-step :title="$t('收货')"></el-step>
        <el-step :title="$t('评价')"></el-step>
      </el-steps>
    </div>
    <div v-if="addr_data">
      <div class="font-bold text-xl text-left mb-3">
        {{ $t("选择收货地址") }}
      </div>
      <div>
        <List :span="3" :data="addr_data" v-slot="{ item }" :class="{ more: isMore }">
          <Radio class="w-full pt-2 pr-1px show flex h-7rem justify-between" :item="item" v-model="select.v">
            <div class="text-left p-3 overflow-hidden w-5/6">
              <p class="flex items-center">
                <span class="name">{{ item.receiver }}</span>
                <span class="text-gray-400 ml-4 phone">{{ item.phone }}</span>
                <template v-if="item.isdefault">
                  <span class="bg-mainHigh text-white text-xs px-1 ml-8">{{
                    $t("默认")
                  }}</span>
                </template>
              </p>
              <p class="text_display">
                <span v-if="item.area">{{ item.area.names }}</span>
                {{ item.address }}
              </p>
            </div>
            <div class="
                                                                                                          mt-2
                                                                                                          text-gray-400 text-sm
                                                                                                          disp
                                                                                                          invisible
                                                                                                          w-1/6
                                                                                                          space-y-3
                                                                                                          pt-2
                                                                                                        ">
              <span @click.stop="modify(item)" class="block">
                <i class="iconfont icon-bianji"></i>
                {{ $t("修改") }}
              </span>
              <!-- <span @click="setDefault(item)" class="block">{{
                $t("设为默认")
              }}</span> -->
            </div>
          </Radio>
        </List>
        <div class="flex justify-between text-base pt-3.5 pb-12">
          <div v-if="isMore" @click="isMore = !isMore" class="cursor-pointer">
            <span>{{ $t("展开全部") }}</span>
            <span class="iconfont icon-xiangxia"></span>
          </div>
          <div v-else @click="isMore = !isMore" class="cursor-pointer">
            <span>{{ $t("收起") }}</span>
            <span class="iconfont icon-xiangshang"></span>
          </div>
          <div @click="addMessage" class="cursor-pointer">
            <span class="iconfont icon-tianjia"></span>
            <span>{{ $t("添加收货地址") }}</span>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="dialogModifyVisible" width="30%">
        <AddAddress :title="title" :addr_message="addr_message" v-if="show" @remodify="remodify"></AddAddress>
      </el-dialog>
      <el-dialog :visible.sync="dialogAddVisible" width="30%">
        <AddAddress v-if="show" @reload="re_add"></AddAddress>
      </el-dialog>

      <div class="title product mt-10">
        <h1>{{ $t("商品信息") }}</h1>
      </div>
      <div class="title2 base">
        <p>{{ $t("商品") }}</p>
        <p>
          {{ $t("参数") }}
        </p>
        <p>
          {{ $t("数量") }}
        </p>
        <p>
          {{ $t("单价") }}
        </p>
        <p>
          {{ $t("优惠") }}
        </p>
        <p>
          {{ $t("小计") }}
        </p>
      </div>

      <div v-for="item in cartProducts" :key="item.id">
        <ProductInfo class="" :data="item" :quantity="item.quantity"></ProductInfo>
      </div>
    </div>
    <div class="mt-8 foot" style="display:flex;justify-content:flex-end">

      <div class="text-gray-500 flex flex-col items-start mr-8">
        <p>
          <span>{{ $t("商品总额") }}：</span>
          <span>{{ $p(totalMoney) }}</span>
        </p>



        <p class="mt-4">
          <span class="text-left">{{ $t("实际付款") }}：</span>
          <span class="text-red-500 text-3xl ml-0">{{
            $p(totalMoney)
          }}</span>
        </p>
        <div class="text-left pt-5">
          <el-button type="danger" @click="submitForm">{{
            $t("提交订单")
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProductInfo from "/src/components/product/dealInfo.vue";
import List from "@/components/base/list.vue";
import Radio from "@/components/base/radio.vue";
import AddAddress from "@/components/mine/addAddress.vue";
import {
  onMounted,
  ref,
  reactive,
  computed
} from "@vue/composition-api";

export default {
  components: { ProductInfo, List, Radio, AddAddress },
  setup(props, ctx) {
    const title = ref();
    const dialogModifyVisible = ref(false);
    const dialogAddVisible = ref(false);
    const show = ref(true);
    const isMore = ref(true);
    const addr_data = ref();
    // 地址信息
    const reload = async () => {
      const res = await ctx.root.$callapi("user/getAddressList", {
        page: 1,
        size: 50,
      });
      let obj = {}
      res.data?.items?.forEach((item, index) => {
        if (item.id == select.v) {
          obj = item
          res.data.items.splice(index, 1)
          return
        }
      })
      if (obj.id) {
        res.data?.items?.unshift(obj)
      }
      console.log(res.data);

      addr_data.value = res.data;
    };
    const user = computed(() => ctx.root.$store.getters.user);
    const select = reactive({ v: user.value.user_lock_address });
    onMounted(() => {
      reload()
    })


    // 商品信息发送到子组件
    const cartProducts = ref()
    const totalMoney = ref()
    const getConfirmCart = async () => {
      let param = ctx.root.$route.query
      ctx.root.$doing()
      let res = await ctx.root.$callapi('user/getConfirmOrderInfo', param)
      ctx.root.$done()
      if (res.code == 0 && res.data) {
        res.data?.items.map(item => {
          item.remark = ''
          item.sumprice = item.products.items.map(i => {
            i.attrs = i.attribute_text?.split('|')
            return i.subtotal
          }).reduce((a, b) => a + b, 0).toFixed(2)

        })
        totalMoney.value = res.data.total_money
        cartProducts.value = res.data.items

      }

    }
    getConfirmCart()




    //todo
    // 计算价格
    const money_info = reactive({
      goods: null,
      express: null,
      discount: null,
      package: null,
      declare: null,
      total: null,
    });

    //  max(flightAdvance?.value?.startprice, flightAdvance?.value?.otherprice * e.product.weight * e.quantity)

    const addr_message = ref();
    const modify = async (item) => {
      const addr_item = await ctx.root.$callapi("user/getAddress", {
        aid: item.id,
      });
      addr_message.value = addr_item.data;
      title.value = ctx.root.$t("修改");
      dialogModifyVisible.value = true;
      show.value = false;
      ctx.root.$nextTick(() => {
        show.value = true;
      });
    };
    const remodify = () => {
      reload();
      dialogModifyVisible.value = false;
    };
    const addMessage = () => {
      dialogAddVisible.value = true;
    };
    const re_add = () => {
      reload();
      dialogAddVisible.value = false;
    };
    const setDefault = async (item) => {
      item.isdefault = true;
      item.aid = item.id;
      await ctx.root.$callapi("user/saveAddress", item);
      reload();
    };

    // 提交订单
    const submitForm = async () => {
      if (select.v) {
        let params = {
          scene: 'cart',
          address_id: select.v,
          param: { cids: ctx.root.$route.query.cids },
        }
        ctx.root.$doing()
        let res = await ctx.root.$callapi('user/createOrder', params)
        ctx.root.$done()
        if (res.code == 0 && res.data) {
          await ctx.root.$toast(ctx.root.$t('订单创建成功'), 'success')
          await ctx.root.$loadUserInfo()
          ctx.root.$router.push({
            path: "/mine/order/" + ctx.root.$route.query.curWh,
            query: { q: "unpay" },
          });
        }
      } else {
        ctx.root.$toast(ctx.root.$t("您还未选择收货地址"), "warning");
      }
    };

    const readypay = ref(null);


    return {
      addr_data,
      select,

      money_info,
      isMore,
      reload,
      dialogModifyVisible,
      title,
      modify,
      show,
      addr_message,
      remodify,
      addMessage,
      dialogAddVisible,
      re_add,
      setDefault,
      submitForm,

      readypay,
      cartProducts,
      totalMoney
    };
  },
};
</script>
<style scoped lang="scss">
.more :nth-child(n + 4) {
  @apply hidden;
}

.show {
  &:hover {
    .disp {
      @apply visible;
    }
  }
}

.step ::v-deep .el-step__head.is-process {
  @apply;
  border-color: #c0c4cc;
  color: #c0c4cc;
}

.step ::v-deep .el-step__title.is-process {
  color: #c0c4cc;
  font-weight: normal;
}

.title {
  text-align: start;

  >h1 {
    font-size: 1.125rem;
    margin-bottom: 1rem;
    font-weight: bold;
  }

  >p {
    margin-bottom: 0.5rem;
  }
}

.base {
  @apply;
  display: grid;
  grid-template-columns: 3fr 2fr 2fr repeat(3, 1fr);
}

.title2 {
  @apply border bg-gray-200 py-1;
}

.text_display {
  overflow: hidden;
  width: 100%;
  height: 3rem;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
